import { keyBy } from 'utils/arrayHelpers';
import { AssociatedEntity } from '../domain';

export const convertIdsToEntities = <E extends AssociatedEntity>(
  ids: number[],
  allEntities: E[],
): AssociatedEntity[] => {
  const allEntitiesById = keyBy(allEntities, ({ id }) => id);
  return ids.flatMap((id) => allEntitiesById[id]).filter((entity) => !!entity);
};
